module.exports = __webpack_public_path__ + "static/media/deleteIcon.c17e8f36.svg";